import React, { useEffect, useState, useRef } from "react";
import $, { data } from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import EditUser from "../../components/Modals/Settings/EditUser";

function UsersList() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const PINE_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const { setGlobalLoading, token } = useOutletContext();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [options, setoptions] = useState([]);
  const [EditModel, setEditModel] = useState(false);
  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/settings/get_users_list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setoptions(response.data.users || []);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

useEffect(() => {
    if (options.length > 0) return;
    fetchOptions();
}, []);

  const OpenEditUserModal = (id) => {
  //  setGlobalLoading(true);
    setSelectedUserId(id);
    setEditModel(true);
  };

 const columns = [
    {
      accessorKey: "id",
      header: "ID",
      size: 80,
      Cell: ({ row }) => {
              return (
                <div className="d-flex align-items-center file-name-icon">
                    <a href="javascript:void(0)" onClick={() => OpenEditUserModal(row.original.id)} title="Edit User">
                    <img
                      src={
                        row.original.userpic
                          ? `${PINE_BASE_URL}/files/media/${row.original.userpic}`
                          : `${PINE_BASE_URL}/files/media/nologo.png`
                      }
                      className="img-fluid avatar avatar-md border rounded-circle"
                      alt="user"
                      style={{ width: "40px", height: "40px", objectFit: "contain" }}
                      onError={(e) => {
                        e.target.onerror = null;
                      //  e.target.src = `${PINE_BASE_URL}/files/media/nologo.png`;
                       e.target.src = `${PINE_BASE_URL_BACK}employee/${row.original.userpic}`
                      }}
                    />
                    </a>
                  <div className="ms-2">
                    <h6 className="fw-medium mb-0">{row.original.id}</h6>
                  </div>
                </div>
              );
            },
    },{
      accessorKey: "username",
      header: "User Name",
      size: 150,
        Cell: ({ row }) => (
          <a
            href="javascript:void(0)"
            onClick={() => OpenEditUserModal(row.original.id)}
            title="Edit User"
            style={{ cursor: "pointer", fontWeight: "bold", color: "#000000ff", textDecoration: "none" }}
          >
            {row.original.username}
          </a>
        ),
      },{
      accessorKey: "firstname",
      header: "First Name",
      size: 150,
    },{
      accessorKey: "lastname",
      header: "Last Name",
      size: 70,
    },{
      accessorKey: "designation_name",
      header: "Designation",
      size: 120,
    },{
      accessorKey: "status",
      header: "Status",
      size: 70,
    },{
      accessorKey: "admin",
      header: "Admin",
      size: 40,
      Cell: (info) => info.cell.getValue() === "1" ? "Yes" : "No",
    },{
      accessorKey: "unlock",
      header: "Unlock",
      size: 40,
      Cell: (info) => info.cell.getValue() === "1" ? "Yes" : "No",
    },{
      accessorKey: "last_login",
      header: "Last Login",
      size: 70,
    },{
      accessorKey: "last_active",
      header: "Last Active",
      size: 70,
    },
  ];

    return (
    <>
     <div className="content">
		<div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
			<div className="my-auto mb-2">
				<h2 className="mb-1">All Users</h2>
			</div>
		</div>
		<div className="card">
		    <div className="card-body p-0">
				<div className="custom-datatable-filter table-responsive">
					<MaterialReactTable
						columns={columns}
						data={options}
						initialState={{	pagination: { pageSize: 200 },}}
						muiTableBodyRowProps={{sx: {height: "20px"},}}
						muiTableBodyCellProps={{sx: {padding: "2px 4px"},}}
						muiTableHeadCellProps={{sx: {padding: "2px 4px", height: "30px"},}}
					/>;
				</div>
			</div>
		</div>
        {EditModel && (
        <EditUser
          id={selectedUserId}
          onClose={() => {
            setEditModel(false);
            fetchOptions();
          }}
        />
      )}
     </div>   
    </>
  )

}

export default UsersList